/*Shopify.onCartUpdate = async function (cart) {
	document.querySelector('.topbar-cart-count').textContent = cart.item_count;
}*/
jQuery(function($){
    $(".brands_list_alphabetical_filter_wrapper a").click(function(e) {
		e.preventDefault();
		var thisElscroll = $(this).attr('href');
		$('html, body').animate({
			scrollTop: $(thisElscroll).offset().top
		}, 500);
	});
	
	var clList1 = new Swiper(".collections-list-slider-1", {
		freeMode: true,
		loop: false,
		grabCursor: true,
		showNavigation: true,
        showPagination: true,
		pagination: {
            el: ".collections-list-slider-section-1 .swiper-pagination",
            clickable: true,
            bulletClass: "sf__dot",
            bulletActiveClass: "sf__dot-active",
            renderBullet: function (index, className) {
                return (
                    '<span class="' + className+ '"><svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg></span>'
                );
            },
        },
		navigation: {
			nextEl: ".collections-list-slider-section-1 .swiper-button-next",
			prevEl: ".collections-list-slider-section-1 .swiper-button-prev",
		},
		breakpoints: {
            768: {
				slidesPerView: 4,
				slidesPerGroup: 1,
            },
            1280: {
				slidesPerView: 5,
				slidesPerGroup: 1,
            }
        }
	});
	var clList2 = new Swiper(".collections-list-slider-2", {
		freeMode: true,
		loop: false,
		grabCursor: true,
		showNavigation: true,
        showPagination: true,
		pagination: {
            el: ".collections-list-slider-section-2 .swiper-pagination",
            clickable: true,
            bulletClass: "sf__dot",
            bulletActiveClass: "sf__dot-active",
            renderBullet: function (index, className) {
                return (
                    '<span class="' + className+ '"><svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg></span>'
                );
            },
        },
		navigation: {
			nextEl: ".collections-list-slider-section-2 .swiper-button-next",
			prevEl: ".collections-list-slider-section-2 .swiper-button-prev",
		},
		breakpoints: {
            768: {
				slidesPerView: 4,
				slidesPerGroup: 1,
            },
            1280: {
				slidesPerView: 5,
				slidesPerGroup: 1,
            }
        }
	});

    $(".pageIframes").each(function(){
		$('#'+$(this).attr('id')).on('load', function () {
          $('.iframe-loading-img').fadeOut('slow');
        });
    	iFrameResize({ log: false, autoResize:true, inPageLinks: true }, '#'+$(this).attr('id'))
	})
})